import { useEffect, useState } from "react";
import { USER_ROLES } from "../constants/userRoles";
import { api } from "../api";
import { useQuery } from "@tanstack/react-query";
import { useFetchStateHelper } from "./useFetchState";

export const useFetchUserByUserId = (id) => {
  const { data: user, ...queryResponse } = useQuery({
    queryKey: ["fetch-user-by-user-id", id],
    queryFn: () => api.users.getUserByUserId(id),
    enabled: Boolean(id),
  });
  const { fetchState } = useFetchStateHelper(queryResponse);
  return { user, fetchState };
};

export const useFetchUser = (id, role = USER_ROLES.FARMER) => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (id) {
      api.users
        .fetchOne(id, role)
        .then((res) => {
          setUser(res.data.user);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [id, role]);

  return { isLoading, user };
};
